module.exports = __webpack_public_path__ + "img/t4-i22.9a8741c4.jpg";